<template>
  <div class="accum" :class="cssType">
    <CountDown :realTime="state.realTime" class="count-down" @end="handleEnd" />
    <Banner />
    <AppLang class="app-lang" type="accum" />
    <ValidateUser :style="{ zIndex: state.validateUserDialogOpen > 0 ? 1000 : 3 }" @dialogOpen="handleValidateUserDialogOpen"/>
    <Rewards
      :rewardList="state.rewardList"
      :rechargeDiamond="state.rechargeDiamond"
      :style="{ zIndex: state.dialogOpen > 0 ? 1000 : 2 }"
      @dialogOpen="handleDialogOpen"
      @rewarded="reset"
    />
    <Rule style="z-index: 2;" />
    <AppFooter />
    <ActFloat v-if="state.dialogOpen <= 0" />
    <ActTimeDialog v-model="state.actTimeDialog.visible" />
  </div>
</template>

<script setup>
import { reactive, watch, onMounted, onUnmounted } from 'vue'
import Banner from './components/Banner'
import AppLang from '@/components/AppLang'
import ValidateUser from '@/components/ValidateUser/ActAccum'
import Rewards from './components/Rewards'
import Rule from './components/Rule'
import AppFooter from '@/components/AppFooter'
import ActFloat from './components/ActFloat'
import { useLog } from '@/composables/useLog'
import { isMobile } from '@/utils'
import AccumApi from '@/config/accumApi'
import { useStore } from 'vuex'
import CountDown from './components/CountDown'
import ActTimeDialog from './components/Dialog/ActTime'
const store = useStore()
const log = useLog()
log.track('act_accum_page_entry', {
  referrer: document.referrer
})
const cssType = isMobile ? 'mobile' : 'pc'
const state = reactive({
  validateUserDialogOpen: 0,
  dialogOpen: 0,
  rewardList: [],
  rechargeDiamond: 0,
  serverTime: 0,
  realTime: 0,
  logTime: 0,
  actTimeDialog: {
    visible: false
  }
})

const handleEnd = () => {
  state.actTimeDialog.visible = true
}

watch(() => store.state.cpUserInfo, () => {
  reset()
}, { deep: true })

watch(() => store.state.locale, () => {
  reset()
})

const handleDialogOpen = (visible) => {
  state.dialogOpen = visible ? state.dialogOpen + 1 : state.dialogOpen - 1
}
const handleValidateUserDialogOpen = (visible) => {
  state.validateUserDialogOpen = visible ? state.validateUserDialogOpen + 1 : state.validateUserDialogOpen - 1
}

const getRewardList = async () => {
  const params = {
    accountNum: store.state.cpUserInfo.accountNum,
  }
  const res = await AccumApi.getRewardList(params)
  const list = res.list || []
  list.sort((a, b) => a.needPurchaseCount - b.needPurchaseCount)
  list.forEach(item => {
    item.status = getStatus(item)
  })
  state.rewardList = res.list || []
  state.rechargeDiamond = res.totalMergePrdCount || 0
  if (!state.serverTime) {
    state.serverTime = res.timestamp * 1000
    state.realTime = state.serverTime
    state.logTime = Date.now()
    startSetServerTime()
  }
}

const startSetServerTime = () => {
  setInterval(() => {
    const now = Date.now()
    const diff = now - state.logTime
    state.realTime = state.serverTime + diff
  }, 1000)
}

const getStatus = (item) => {
  // collectTimesLimit 奖励领取次数上限(活动配置)
  // collectedTimes 已领奖励次数
  // canCollectTimes 当前可领奖励次数上限
  if (item.collectTimesLimit === 0) { // 奖励领取时间结束后，服务端collectTimesLimit会返回0，统一展示goRecharge按钮
    return 'goRecharge'
  }
  if (item.collectedTimes >= item.collectTimesLimit) {
    return 'received'
  }
  if (item.collectedTimes < item.canCollectTimes) {
    return 'canReceive'
  }
  if (item.canCollectTimes < item.collectTimesLimit) {
    return 'notReach'
  }
  console.error('getStatus error', item)
}

const init = () => {
  getRewardList()
}
init()

const reset = () => {
  getRewardList()
}

// 监听页面显示出来的时候就重新获取rewardList
onMounted(() => {
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      reset()
    }
  }
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // 组件卸载时移除监听器
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>